import React, { forwardRef } from "react";
import Flex from "../box/Flex";
const DialogContent = forwardRef(function DialogContent(props, ref) {
    return React.createElement(Flex, Object.assign({}, props, { overflow: "auto", flex: 1, ref: ref }));
});
export default DialogContent;
//# sourceMappingURL=DialogContent.js.map